import auth0js from "auth0-js";

// const webAuth = new auth0js.WebAuth({
//   domain: "dev-3yjin90z.us.auth0.com",
//   clientID: "CQK7qF4iOl90HWaIVX3iTljiGMFbP02P",
//   audience: "https://stt-api-stage.eagletechsolutions.uk/weatherforecast/",
//   redirectUri: window.location.origin,
//   // responseType: 'token',
// });
const webAuth = new auth0js.WebAuth({
  domain: "dev-mse3vvjz8n3ob4gf.us.auth0.com",
  clientID: "Xmb96mNN923GAgBJfaj5xUyN227h0Ns3",
  audience: "https://api.qrcode-stt.com/weatherforecast",
  redirectUri: window.location.origin,
  // responseType: 'token',
});

// const webAuth = new auth0js.WebAuth({
//   domain: "dev-8l8nc2e5.us.auth0.com",
//   clientID: "D6BvM3mLMIYVVS3BRAQuG1rcODMFyMYV",
//   audience: "https://orbit.com/",
//   redirectUri: window.location.origin,
//   // responseType: 'token',
// });
export default webAuth;
